import { Component, OnInit, PLATFORM_ID, Inject, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { ListsService } from '../../lists.service';
import { DataService } from '../../data.service';
import { localStorageName } from '../../names';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';


const STATE_KEY_ARTICLE = makeStateKey('consumer_menu_aricle');

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {


  diagnoza_res;
  toggleMenu = false;

  // article$;
  public article: any = null;

  showMenu1 = false;
  showMenu2 = false;

  isSticky: boolean = false;

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    this.isSticky = window.pageYOffset >= 10;
  }

  constructor(
    public router: Router,
    private _data: DataService,
    public _lists: ListsService,
    private state: TransferState,
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platform: any
  ) {}

  hideMenu(item?) {
    if (item) {
      setTimeout(() => {
        this[item] = false;
      }, 50);
    } else {
      setTimeout(() => {
        this.toggleMenu = false;
        this.showMenu1 = false;
        this.showMenu2 = false;
      }, 50);
    }

  }

  ngOnInit() {
    if (isPlatformBrowser(this.platform)) {
      this.diagnoza_res = localStorage.getItem(localStorageName.diagnozaOdp);
    }

    this.article = this.state.get(STATE_KEY_ARTICLE, <any>null);

    if (!this.article) {
      const params = new HttpParams()
        .set('page', '1')
        .set('direction', 'desc')
        .set('sort', 'publish_date')
        .set('perPage', '1');
      this.http.get(`${environment.apiUrl}/platform/content/article/salonexpert`, {params})

      .pipe(map((res: any) => {
        res.data[0].pagelink = `/artykuly/${res.data[0].slug}`;
        return res.data[0];
      }))
      .subscribe(
        (res: any) => {
          this.article = res;
          this.state.set(STATE_KEY_ARTICLE, <any>res);
        },
        err => {
          console.error(err);
        }
      );
    }

  }


}
